<button type="button" class="btnn close_btn" (click)="closeModal()">
  <mat-icon>close</mat-icon>
</button>

<div class="modal-box">
  <div class="modal_image_container" [class.clickable]="adData?.url" (click)="onAdClick()">
    <figure>
      <img [src]="displayImage || assetsConst.homeBanner" [alt]="displayTitle || 'Welcome'" />
    </figure>
    <div class="ad-content" *ngIf="displayTitle || displayDescription">
      <h2 class="ad-title" *ngIf="displayTitle">{{ displayTitle }}</h2>
      <p class="ad-description" *ngIf="displayDescription">{{ displayDescription }}</p>
    </div>
  </div>
</div>

